<template>
  <div>
    <PageTitleVue> Funcionários </PageTitleVue>
    <section>
      <div
        class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
      >
        <div
          class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white"
        >
          <DropDownOptions
            v-model="selectedFilter"
            :label="'Função'"
            :options="['Todos', ...filters]"
          />

          <SearchInput v-model="searchTerm" />
        </div>

        <DataTable :data="filteredData">
          <template #head>
            <th scope="col" class="px-6 py-3">Nome</th>
            <th scope="col" class="px-6 py-3">Documentos</th>
            <th scope="col" class="px-6 py-3">Celular</th>
            <th scope="col" class="px-6 py-3">Contratação</th>
            <th scope="col" class="px-6 py-3">#</th>
          </template>
        </DataTable>
      </div>
    </section>

    <FloatCreateVue :link="'employees-new'" :icon="'fa-solid fa-user-plus'" />
  </div>
</template>

<script setup>
import DropDownOptions from "@/components/Tables/DropDownOptions.vue";
import FloatCreateVue from "@/components/Buttons/FloatCreate.vue";
import SearchInput from "@/components/Tables/SearchInput.vue";
import PageTitleVue from "@/components/Titles/PageTitle.vue";
import EmployeesService from "./services/employees.service";
import DataTable from "./components/DataTable.vue";
import EmployeesTable from "./components/Table.vue";
import { onBeforeMount, onMounted, ref, computed } from "vue";
import { dataEmployee } from "./store";
import { storeApp } from "@/store";

const store = dataEmployee;
const appStore = storeApp.state;
const dataTable = ref([]);
const searchTerm = ref("");
const selectedFilter = ref("");

const filters = computed(() => {
  if (dataTable.value) {
    return [...new Set(dataTable.value.map((i) => i.role))];
  }
});

const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable?.value?.filter((row) => {
    if (selectedFilter.value === "Todos") {
      selectedFilter.value = "";
    }

    const matchesDropdown =
      !selectedFilter.value || row.role === selectedFilter.value;

    const matchesSearch =
      !searchTerm.value ||
      ["name", "role", "cpf", "registered", "phone"].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      );

    return matchesDropdown && matchesSearch;
  });
});

async function getEmployees() {
  appStore.loading = true;
  return await EmployeesService.getAllEmployees()
    .then((res) => {
      dataTable.value = res.data;
      appStore.loading = false;
    })
    .catch((err) => {
      appStore.loading = false;
      console.log(err);
    });
}

onBeforeMount(() => {
  store.commit("reset");
});

onMounted(async () => {
  appStore.loading = true;
  await getEmployees();
  appStore.loading = false;
});
</script>
